'use client'

import { useCallback, useEffect, useState } from 'react'

import { TVesselJourneyResponse } from '@/api/v1/resources/vesselJourney'
import { getBookmarkedVessels, toggleBookmark } from '@/app/lib/bookmarks'

const useLocalBookmarks = () => {
  const [bookmarks, setBookmarks] = useState<TVesselJourneyResponse[] | null>(null)

  // Load bookmarks on mount
  useEffect(() => {
    try {
      const list = getBookmarkedVessels()
      setBookmarks(list)
    } catch (e) {
      console.warn('Unable to load bookmarks', e)
      setBookmarks([])
    }
  }, [])

  const removeBookmarkNow = useCallback((v: TVesselJourneyResponse) => {
    try {
      const res = toggleBookmark(v)
      setBookmarks(res.list)
    } catch (e) {
      console.error('Failed to remove bookmark', e)
    }
  }, [])

  const addBookmarkNow = useCallback((v: TVesselJourneyResponse) => {
    try {
      const res = toggleBookmark(v)
      setBookmarks(res.list)
    } catch (e) {
      console.error('Failed to add bookmark', e)
    }
  }, [])

  return {
    bookmarks,
    addBookmarkNow,
    removeBookmarkNow
  }
}

export default useLocalBookmarks
